export function apiErrorMessage(error, fallback) {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    const message = detail.map(item => {
      if (typeof item === "string") return item;
      const field = Array.isArray(item?.loc)
        ? item.loc.filter(part => part !== "body").join(".")
        : "";
      const reason = typeof item?.msg === "string" ? item.msg : "Invalid value";
      return field ? `${field}: ${reason}` : reason;
    }).filter(Boolean).join("; ");
    return message || fallback;
  }
  if (detail && typeof detail === "object") {
    if (typeof detail.message === "string") return detail.message;
    if (typeof detail.error === "string") return detail.error;
    if (Array.isArray(detail.errors)) {
      const message = detail.errors.map(item => typeof item === "string" ? item : item?.msg).filter(Boolean).join("; ");
      return message || fallback;
    }
  }
  return typeof error?.message === "string" ? error.message : fallback;
}
